import { DeviceFormModal } from "@/modules/devices/components/DeviceFormModal";
import { DeviceTable } from "@/modules/devices/components/DeviceTable";
import { useUrlTableState } from "@/shared/hooks/useUrlState";

interface OrgDevicesTabProps {
	organizationId: string;
}

export function OrgDevicesTab({ organizationId }: OrgDevicesTabProps) {
	const { page, limit, setPage } = useUrlTableState({ prefix: "devices" });

	return (
		<>
			<DeviceTable
				organizationId={organizationId}
				page={page}
				limit={limit}
				onPageChange={setPage}
			/>
			<DeviceFormModal organizationId={organizationId} organizations={[]} />
		</>
	);
}
